import { createFileRoute } from "@tanstack/react-router";

import { PaymentHistory } from "./-components/payment-history";
import { SharedDocuments } from "./-components/shared-documents";
import { UserCoachAgreement } from "./-components/user-coach-agreement";

export const Route = createFileRoute("/_user/coaching/$engagementId/admin")({
  staticData: { title: "Billing & Documents" },
  component: RouteComponent,
});

function RouteComponent() {
  const { engagementId } = Route.useParams();

  return (
    <div className="min-h-engagement-card space-y-6">
      <UserCoachAgreement engagementId={engagementId} />

      <PaymentHistory engagementId={engagementId} />

      <SharedDocuments engagementId={engagementId} />
    </div>
  );
}
